export const REFERRER = {
  WEBSHOP: 'webshop',
} as const
